"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var I18n = require("i18n-js");
var user_context_provider_1 = require("@reverbdotcom/commons/dist/components/user_context_provider");
var selectable_credit_card_list_query_1 = require("./selectable_credit_card_list_query");
function CheckoutPaymentSelectionContinueButton(props) {
    var isDisabled = false;
    if (props.data && props.data.me && props.data.me.creditCards.length > 0) {
        var selectedCard = props.data.me.creditCards.find(function (cc) { return cc.isSelected; });
        if (selectedCard) {
            isDisabled = selectedCard.needsReverification;
        }
    }
    return (React.createElement("div", null,
        React.createElement("button", { type: "submit", name: "commit", disabled: isDisabled, className: "button button--green width-100 icon-r-arrow-right", "data-disable-with": I18n.t('discovery.bundledCheckout.continueButton.pleaseWait') }, I18n.t('discovery.bundledCheckout.continueButton.continue'))));
}
exports.CheckoutPaymentSelectionContinueButton = CheckoutPaymentSelectionContinueButton;
exports.default = user_context_provider_1.withUserContext(selectable_credit_card_list_query_1.connectCheckoutButtonQuery(CheckoutPaymentSelectionContinueButton));
//# sourceMappingURL=checkout_payment_selection_continue_button.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/credit_cards/checkout_payment_selection_continue_button.js
// module id = +sFL
// module chunks = 20 21 22